import React, { useEffect, useState, useRef, useContext } from 'react';
import { Link } from 'react-router-dom';
import lottie from 'lottie-web';
import axios from 'axios';
import { AppContext } from '../context/AppContext.jsx';
import AboutUs from '../page-parts/AboutUs.jsx';
import WorksGrid from '../page-parts/WorksGrid.jsx';
import Expertise from '../page-parts/Expertise.jsx';
import SiteLoader from '../components/SiteLoader.jsx';
import Helmet from 'react-helmet';

function Home({ isAboutOpen }) {
	const lottieRef = useRef(null);
	const [page, setPage] = useState(null);
	const [pageSubviews, setPageSubviews] = useState([]);
	const [pageArticles, setPageArticles] = useState([]);
	const [pageMedia, setPageMedia] = useState([]);
	const [pageHero, setPageHero] = useState(null);
	const pageUrl = process.env.REACT_APP_API_PAGE_URL;

	const { isLoading, setIsLoading } = useContext(AppContext);

	useEffect(() => {
		const fetchData = async () => {
			setIsLoading(true);
			try {
				const res = await axios.get(`${pageUrl}f3e831e7-1de2-467c-b0fb-457acc7f2b29`);
				const response = res.data;
				setPage(response);
			} catch (error) {
				console.error('Errore durante il fetch della pagina:', error);
			} finally {
				setIsLoading(false);
			}
		};

		fetchData();
	}, [pageUrl, setIsLoading]);

	useEffect(() => {
		if (page != null) {
			setPageSubviews(page.items);
			setPageArticles(page.articles);
			setPageMedia(page.media);
			setPageHero(page.items[0]);
		}
	}, [page]);

	useEffect(() => {
		//let animation = null;

		//const loadAnimation = () => {
		//	if (pageHero != null && pageHero.media.length) {
		//		setIsLoading(true);
		//		try {
		//			animation = lottie.loadAnimation({
		//				container: lottieRef.current,
		//				renderer: 'canvas',
		//				loop: true,
		//				autoplay: true,
		//				path: pageHero.media[0].url,
		//				rendererSettings: {
		//					preserveAspectRatio: 'xMidYMid slice',
		//				},
		//			});

		//			animation.addEventListener('data_ready', () => {
		//				setIsLoading(false);
		//			});

		//			animation.addEventListener('data_failed', () => {
		//				setIsLoading(false);
		//				console.error('Errore durante il caricamento dell\'animazione');
		//			});
		//		} catch (error) {
		//			console.error('Errore durante il caricamento dell\'animazione:', error);
		//			setIsLoading(false);
		//		}
		//	}
		//};

		//loadAnimation();

		//return () => {
		//	if (animation) {
		//		animation.destroy();
		//	}
		//};
	}, [pageHero, setIsLoading]);

	useEffect(() => {
		if (pageHero == null) return;

		// Imposta il valore iniziale di brightness a 1
		gsap.set('#lottiePlayerWrapper', { filter: 'brightness(1)' });

		gsap.to('#lottiePlayerWrapper', {
			scrollTrigger: {
				trigger: '#lottiePlayerWrapper',
				start: "top+=30% top",
				end: "bottom top",
				scrub: 0,
				toggleActions: "play none none reverse",
				markers: false,
			},
			filter: 'brightness(0.3)',
		});
	}, [pageHero]); 

	return (
		<>
			{/*isLoading && <SiteLoader inSuspance={true} />*/}
			{page && (
				<Helmet>
					<title>{`Epoca - Homepage`}</title> 
					<meta property="og:url" content={`${window.location.origin}`} />
					<meta property="og:type" content="page" />
					<meta property="og:title" content={`Epoca - Communication and Marketing Advisoring`} />
					<meta property="og:site_name" content="epocagroup.it" />
				</Helmet>	
			)}
			{pageHero != null && pageHero.media.length > 0 && (
				<div className='container-fluid' id="lottiePlayerWrapper">
					<div className='row'>
						<div className='col-12 px-0'>
							<div className="video-player vh-100" ref={lottieRef}>
								<div className="mouse small"></div> 
								<video
									playsInline={true}
									muted={true}
									autoPlay={true}
									loop={true}
									controls={false}
									preload="auto"
									poster="/content/img/video-mobile-fallback.png"
									className="h-100 w-100 object-fit-cover">
									<source src={pageHero.media[0].url} />
								</video> 
							</div>
						</div>
					</div>
				</div>
			)}
			{pageSubviews != null && pageSubviews.length > 1 && (
				<>
					<AboutUs />
					<WorksGrid id={pageSubviews[2].id} />
					<Expertise id={pageSubviews[3].id} />
				</>
			)}
		</>
	);
}

export default Home;
